const migrations = [
  import('./2025-12-29-auth'),
  import('./2025-12-29-app'),
  import('./2025-12-29-app-server'),
  import('./2025-12-29-sync-engine'),
  import('./2025-12-29-sync-engine-client'),
  import('./patient-findings-view'),
  import('./2026-06-16-entra-groups'),
  import('./2026-06-22-patient-cost-carrier-exemptions'),
  import('./2026-07-03-article-category-ids'),
  import('./R-adteams'),
]

export default migrations
